<template>
  <b-modal
      v-model="visible"
      title="افزودن سگمنت پایه"
      cancel-variant="outline-secondary"
      :no-close-on-backdrop="true"
      hide-footer
      centered
      size="md"
  >
    <b-overlay
        :show="loading"
        rounded="sm"
    >
      <b-form @submit.prevent>
        <b-row>
          <b-col md="6">
            <b-form-group
                label="عنوان"
                label-for="Family"
            >
              <b-form-input
                  v-model="form.Title"
                  autocomplete="off"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="نوع سگمنت" label-for="segmentType">
              <z-segment-basic-types v-model="form.Type" :multiple="false" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group label="عملگر" label-for="segmentType">
              <v-select
                  v-model="form.Operator"
                  dir="rtl"
                  :reduce="x => x.value"
                  :clearable="true"
                  :disabled="selectedItem && selectedItem.LockOperandAndOperator"
                  label="text"
                  :options="segmentOperators"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="عملوند" label-for="segmentType">
              <v-select
                  v-if="operandItems.length"
                  v-model="form.Operand"
                  dir="rtl"
                  :reduce="x => x.Value"
                  :clearable="true"
                  :disabled="selectedItem && selectedItem.LockOperandAndOperator"
                  label="Title"
                  :options="operandItems"
              />
              <b-form-input
                  v-else
                  v-model="form.Operand"
                  autocomplete="off"
                  :disabled="selectedItem && selectedItem.LockOperandAndOperator"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group class="mt-1 mb-2">
              <b-form-checkbox v-model="form.AutoInsertNewUser" class="custom-control-info">
                کاربران جدید به این سگمنت اضافه شوند
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end mt-3">
          <b-button
              variant="primary"
              class="mr-1"
              @click="save"
          >
            <feather-icon
                icon="fa fa-loading"
                class="mr-50"
            />
            ذخیره
          </b-button>
          <b-button
              variant="outline-secondary"
              @click="visible = false"
          >
            انصراف
          </b-button>
        </div>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import ZSegmentBasicTypes from "@/tools/segmentBasicTypes.vue";
import {mapState} from "vuex";

export default {
  name: "addSegmentBase",
  components: { ZSegmentBasicTypes },
  props: {
    show:{ type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      form: {
        Title: null,
        Type: null,
        Operand: null,
        Operator: null,
        AutoInsertNewUser: false
      },
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(val) {
        return this.$emit('update:show', !!val)
      }
    },
    ...mapState('zirehState', { segmentTypes: state => state.segmentBasicTypesSelect }),
    ...mapState('zirehState', { flag: state => state.segmentBasicTypesSelectFlag }),
    selectedItem() {
      return this.segmentTypes.find(item => item.Value === this.form.Type)
    },
    operandItems() {
      return this.selectedItem ? this.selectedItem.Details : []
    },
    segmentOperators() {
      return this.operandItems.length
          ? this.enums('segmentOperator').filter(item => item.key === 'equal')
          : this.enums('segmentOperator')
    }
  },
  watch: {
    'form.Type'() {
      this.form.Operator = null
      this.form.Operand = null
    },
    visible(val) {
      if (!val) {
        this.form.Title = null
        this.form.Type = null
        this.form.Operand = null
        this.form.Operator = null
      }
    }
  },
  methods: {
    save() {
      this.loading = true
      this.$http.post(this.$api.segmentBasic.add, this.form)
          .then(response => {
            this.$emit('add', response.data)
            this.loading = false
            this.visible = false
          })
          .finally(() => {
            this.loading = false
          })
    },
  }
}
</script>